export default __webpack_public_path__ + "static/media/github.3a5ccf39.svg";